/* Per-pod fire package: Shopify presentment price, native extras state and reviewed enquiry handoff. */
(() => {
  'use strict';
  if (window.FocusPodFireSafety) return;
  const code = 'sprinkler_fire_alarm';
  const source = document.getElementById('fp-fire-combo-data');
  const packageData = source ? JSON.parse(source.textContent) : null;
  const handoffKey = 'focuspod:fire-package:enquiry:v1';
  function register(data, book) {
    if (!packageData || data.extras.some(extra => extra.code === code)) return;
    const verified = packageData.available && Number.isSafeInteger(packageData.variantId) && packageData.variantId > 0 && Number.isSafeInteger(packageData.priceCents) && packageData.priceCents > 0 && packageData.currency === data.currency;
    data.extras.push({code, label:packageData.label, note:'', priceCents:verified ? packageData.priceCents : 0, quoteRequired:!verified});
    if (verified && book) {
      book.extras[code] = packageData.variantId;
      book.variants[packageData.variantId] = {[data.currency]:packageData.priceCents};
    }
  }
  window.FocusPodFireSafety = {register};
  const models = {solo:'FocusPod Solo',solo_plus:'FocusPod Solo Plus',duo:'FocusPod Duo',team:'FocusPod Team',meet:'FocusPod Meet',max:'FocusPod Max'};
  const normalize = value => String(value || '').replace(/-/g, '_');
  document.addEventListener('click', event => {
    const builder = window.FocusPodRegionalBuilder;
    const snapshot = builder?.snapshot();
    const link = event.target.closest('[data-fp-fire-link]');
    const quoteButton = event.target.closest('#fp-email-quote,#fp-email-quote-fallback,#builder-email');
    const selections = snapshot?.designs?.length ? snapshot.designs : snapshot ? [snapshot.state] : [];
    const fireSelected = selections.some(selection => selection.extras?.includes(code));
    if (!link && !(quoteButton && fireSelected)) return;
    if (!link && snapshot && !['AU','NZ'].includes(snapshot.country) && quoteButton?.hasAttribute('data-fp-quote-handoff')) return;
    const target = link || document.querySelector('[data-fp-fire-link]');
    if (!target || !snapshot) return;
    const model = normalize(snapshot.state.model);
    if (!models[model]) return;
    const url = new URL(target.href);
    url.searchParams.set('model', model);
    try {
      const data = JSON.parse(document.querySelector('.us-configurator [data-builder-data]').textContent);
      const money = cents => new Intl.NumberFormat(data.locale || 'en', {style:'currency',currency:snapshot.currency,currencyDisplay:'code',maximumFractionDigits:(!['AU','NZ'].includes(data.country))?0:(2)}).format(cents / 100);
      const lines = [packageData.summaryTitle, snapshot.currency + ' · ' + data.taxNote, ''];
      const project = link ? [snapshot.state] : selections;
      project.forEach(selection => {
        const price = builder.calculate(selection);
        const name = models[normalize(selection.model)] || selection.model;
        lines.push(name + ' × ' + selection.quantity);
        ['exterior','interior'].forEach(group => lines.push(selection[group === 'exterior' ? 'customExterior' : 'customInterior'] || data[group].find(finish => finish.code === selection[group])?.name || selection[group]));
        price.lines.forEach(line => lines.push(line.label + ': ' + (line.quoteRequired ? data.copy.quote_required : money(line.priceCents)) + ' / ' + data.copy.per_pod));
        lines.push(money(price.subtotalCents), '');
      });
      sessionStorage.setItem(handoffKey, JSON.stringify({created:Date.now(),summary:lines.join('\n')}));
      url.searchParams.set('fire_configuration','1');
    } catch (_) { /* The model and fire request still travel in the URL. */ }
    if (link) link.href = url.href;
    else {
      event.preventDefault();
      event.stopImmediatePropagation();
      location.assign(url.href);
    }
  }, true);
  function init() {
    document.querySelector('.fp-fire-loading')?.remove();
    const choice = document.querySelector('#fp-fire-choice [data-extra="' + code + '"]');
    if (choice) choice.setAttribute('aria-describedby', 'fp-fire-package-hint');
    const hint = document.querySelector('.fp-fire-hint');
    if (hint) hint.id = 'fp-fire-package-hint';
    // Automated quote services have their own pricebook. A new package uses the
    // existing reviewed enquiry flow until that service explicitly supports it.
    const renameQuote = () => {
      const snapshot = window.FocusPodRegionalBuilder?.snapshot();
      const selections = snapshot?.designs?.length ? snapshot.designs : snapshot ? [snapshot.state] : [];
      const selected = selections.some(selection => selection.extras?.includes(code));
      document.querySelectorAll('#fp-email-quote,#fp-email-quote-fallback').forEach(button => {
        if (!button.dataset.fireOriginalLabel) button.dataset.fireOriginalLabel = button.textContent;
        const label = selected ? packageData.quoteButton : button.dataset.fireOriginalLabel;
        if (button.textContent !== label) button.textContent = label;
      });
    };
    if (packageData) {
      document.querySelector('.us-configurator')?.addEventListener('change', () => requestAnimationFrame(renameQuote));
      document.querySelector('.us-configurator')?.addEventListener('click', () => requestAnimationFrame(renameQuote));
      document.addEventListener('focuspod:cart-synced', renameQuote);
      renameQuote();
    }
    const select = document.querySelector('[data-fp-fire-request]');
    if (!select) return;
    const params = new URLSearchParams(location.search);
    const option = [...select.options].find(item => item.dataset.fireValue === params.get('fire'));
    if (option && !select.value) select.value = option.value;
    const requestType = select.form?.querySelector('[data-ca-enquiry-type]');
    if (option?.dataset.fireValue === 'documents' && requestType?.value === 'project' && !params.has('request')) requestType.value = 'documents';
    const model = normalize(params.get('model'));
    if (option && models[model]) {
      const field = select.form?.querySelector('[data-fp-fire-model]');
      const caModel = select.form?.querySelector('[data-ca-enquiry-model]');
      if (field && !caModel) field.value = models[model];
      if (caModel && !caModel.value) caModel.value = model;
    }
    if (params.get('fire_configuration') === '1') {
      try {
        const saved = JSON.parse(sessionStorage.getItem(handoffKey) || 'null');
        const message = select.form?.querySelector('textarea');
        if (saved && Date.now() - saved.created < 86400000 && typeof saved.summary === 'string' && saved.summary.length < 40000 && message && !message.value.includes(saved.summary)) {
          message.value = [message.value, saved.summary].filter(Boolean).join('\n\n');
          message.dispatchEvent(new Event('input',{bubbles:true}));
        }
      } catch (_) { /* Enquiry remains usable without browser storage. */ }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();



